import { atom } from "recoil";
import { FilterDef } from "../../../constants/FinanceModels";

// The state for requesting an update on Threshold' reports table
export const STATE_THRESHOLD_UPDATING = atom<boolean>({
    key: "state-threshold-updating",
    default: false
});

// The state for requesting an update on Royalties' printouts table
export const STATE_LIVEMONITORING_UPDATING = atom<boolean>({
    key: "state-livemonitoring-updating",
    default: false
});

// The state of active filters on Royalties' reports page
export const STATE_THRESHOLD_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'state-threshold-active-filters',
    default: []
});

// The state of active filters on Royalties' printouts page
export const STATE_LIVEMONITORING_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'state-livemonitoring-active-filters',
    default: []
});
